import React from 'react'
import { ReactComponent as ClockSvg } from './assets/clock.svg'
import { ReactComponent as NotConnectedSvg } from './assets/not-connected.svg'
import { ReactComponent as CheckSvg } from './assets/check.svg'
import { ReactComponent as GlyphSvg } from './assets/glyph.svg'
import { ReactComponent as WifiSvg } from './assets/wifi.svg'
import { ReactComponent as TrashSvg } from './assets/trash.svg'
import { ReactComponent as DeviceCheckSvg } from './assets/device-check.svg'
import { ReactComponent as CopySvg } from './assets/copy.svg'
import { ReactComponent as InfoSvg } from './assets/info.svg'

const ICONS = {
	clock: ClockSvg,
	'not-connected': NotConnectedSvg,
	check: CheckSvg,
	glyph: GlyphSvg,
	wifi: WifiSvg,
	trash: TrashSvg,
	'device-check': DeviceCheckSvg,
	copy: CopySvg,
	info: InfoSvg,
}

const WatchSvg = React.memo(({ icon }) => {
	const Icon = ICONS[icon]
	return Icon ? <Icon /> : null
})

WatchSvg.displayName = 'WatchSvg'
export default WatchSvg
